export default __webpack_public_path__ + "static/media/dublicateJob.ace185f4.svg";